import { useSnapshot } from '../context';

/** The heading printed above a pairing list or standings (hidden on screen). */
export function PrintHeader({ title }: { title: string }) {
  const { tournament: t } = useSnapshot();
  const s = t.settings;
  const details = [
    s.city,
    [s.startDate, s.endDate].filter(Boolean).join(' to '),
    s.chiefArbiter ? `Chief arbiter: ${s.chiefArbiter}` : '',
  ].filter(Boolean);
  return (
    <div className="print-only print-header">
      <p className="print-event">{s.name}</p>
      <p className="print-title">{title}</p>
      {details.length > 0 && <p className="print-details">{details.join(' · ')}</p>}
    </div>
  );
}
